class ErrorExtractor {
  // Extract errors and populate the errorMsg object
  extractErrors = (jsonObject, errorMsg, setErrorMsg) => {
    const newErrorMsg = { ...errorMsg };

    Object.keys(newErrorMsg).forEach((key) => {
      const isListError = Array.isArray(newErrorMsg[key]);
      const jsonError = jsonObject.error ? jsonObject.error[key] : null;

      if (isListError) {
        newErrorMsg[key] = jsonError && jsonError.length > 0 ? jsonError : [];
      } else {
        if (jsonError && jsonError.length > 0) {
          newErrorMsg[key] = ["product_id", "quantity", "unit"].includes(key)
            ? jsonError
            : jsonError[0];
        } else {
          newErrorMsg[key] = "";
        }
      }
    });

    setErrorMsg(newErrorMsg); // Update state
  };

  // Reset all fields in errorMsg object
  resetObject(object) {
    Object.keys(object).forEach((key) => {
      if (["product_id", "quantity", "unit"].includes(key)) {
        object[key] = [];
      } else {
        object[key] = "";
      }
    });

    // Optionally ensure all values are reset
    // object = Object.fromEntries(Object.keys(object).map(key => [key, ""]));

    return object;
  }
}

export default ErrorExtractor;
